import { Button, Card, CircularProgress, Stack, Typography } from '@mui/material'
import { toast } from 'react-toastify'
import { useRestoreMyAccountMutation } from '../../../api/profile'
import { extractApiErrorMessage, logOut } from '../../../utils/api'

export function AccountRecoveryPage() {
  const [restoreMyAccount, { isLoading }] = useRestoreMyAccountMutation()

  const handleRestore = async () => {
    try {
      await restoreMyAccount().unwrap()
      toast.success('Аккаунт восстановлен')
    } catch (error) {
      toast.error(extractApiErrorMessage(error) ?? 'Не удалось восстановить аккаунт')
    }
  }

  const handleLogout = async () => {
    await logOut()
  }

  return (
    <Stack alignItems="center" justifyContent="center" minHeight="100vh" px={2}>
      <Card variant="primaryAdaptiveCard" sx={{ p: 3, maxWidth: 480, width: '100%' }}>
        <Stack gap={2}>
          <Typography variant="black-16-semiBold">Аккаунт удалён</Typography>
          <Typography variant="black-14-normal" color="text.secondary">
            Профиль скрыт из поиска и списка людей. Восстановите аккаунт, чтобы снова пользоваться платформой.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5}>
            <Button variant="follow" onClick={handleRestore} disabled={isLoading}>
              {isLoading ? (
                <Stack direction="row" alignItems="center" spacing={1}>
                  <CircularProgress size={16} color="inherit" />
                  <span>Восстановление...</span>
                </Stack>
              ) : (
                'Восстановить аккаунт'
              )}
            </Button>
            <Button variant="action" onClick={handleLogout} disabled={isLoading}>
              Выйти
            </Button>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  )
}
